import React, { useState, useRef, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  List,
  ListItem,
  ListItemText,
  InputLabel,
  MenuItem,
  Avatar,
  Box,
  Link,
  Divider,
  IconButton,
  Accordion,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  Select,
  Card,
  CardContent,
  Chip,
} from "@mui/material";
import {
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
} from "../../utils/textFieldValidations";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useMediaQuery } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/Logout";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PaymentIcon from "@mui/icons-material/Payment";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { ConstructionOutlined, Person2Rounded } from "@mui/icons-material";
import OnTheWay from "../OnTheWay/OnTheWay";
import Confirmed from "../Confirmed/Confirmed";
import Delivered from "../Delivered/Delivered";
import Cancelled from "../Cancelled/Cancelled";
import Returned from "../Returned/Returned";
import OnTheWayListing from "../OnTheWay/OnTheWayListing";
import ConfirmedListing from "../Confirmed/ConfirmedListing";
import DeliveredListing from "../Delivered/DeliveredListing";
import CancelledListing from "../Cancelled/CancelledListing";
import ReturnedListing from "../Returned/ReturnedListing";
import Header from "../Header/userHeader";
import { useDispatch, useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { Delete, UploadFile } from "@mui/icons-material";
import { getAppToken, getCustomerId } from "../../store/actions/userActions";
import {
  Person as PersonIcon,
  Menu as MenuIcon,
  Edit as EditIcon,
  ArrowBack as ArrowBackIcon,
} from "@mui/icons-material";
import { UserFooter } from "..";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
} from "../../utils/DateFormats";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";

import { useNavigate } from "react-router-dom";

const ProfileInformation = () => {
  const [activeTab, setActiveTab] = useState("Profile Information");
  const isSmallScreen = useMediaQuery("(max-width:767px)");
  const apptoken = useSelector((state) => state.user.apptoken);
  const customerId = useSelector((state) => state.user.customerId);
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const navigate = useNavigate();
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [moduleStatusData, setModuleStatusData] = useState({});
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const libraries = ["places"];
  const autocompleteService = useRef(null);
  const sessionToken = useRef(null);
  const [isEditMode, setEditMode] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [customerData, setCustomerData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    dob: "",
    profilePhoto: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    latitude: "",
    longitude: "",
    status: "",
    searchlocation: "",
    addressId: "",
    isDefault: false,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setCustomerData((customerData) => ({
          ...customerData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);

  const initializeCustomerData = () => {
    setCustomerData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      location: "",
      dob: "",
      profilePhoto: "",
      country: "",
      state: "",
      city: "",
      street: "",
      landmark: "",
      pincode: "",
      latitude: customerData.latitude,
      longitude: customerData.longitude,
      status: "",
      searchlocation: "",
      setCustomerData: "",
      addressId: "",
      isDefault: false,
    });
  };
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  const clearErrors = () => {
    setErrors({});
  };

  //get All Customers data
  useEffect(() => {
    fetchData();
    fetchAddressData();
  }, []);

  const {
    data: createAddress,
    isLoading: createAddressLoading,
    error: createAddressError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createAdddressForProfile"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  //get All Address
  const {
    data: addressData,
    isLoading: isaddressLoading,
    error: addressError,
    fetchData: fetchAddressData,
  } = useFetch(BASE_URL_TEST + urls("getAllManageAddress", customerId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: primaryAddress,
    isLoading: primaryAddressLoading,
    error: primaryAddressError,
    fetchData: fetchSetPrimaryAddress,
  } = useFetch(BASE_URL_TEST + urls("setPrimaryAddress"), {
    method: "POST",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });
  useEffect(() => {
    if (addressError) {
    } else if (addressData && addressData["status"] === true) {
      setAddressList(addressData["data"]);
    }
  }, [addressData, addressError]);

  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries,
    });

    return { isLoaded, loadError };
  };
  const { isLoaded, loadError } = useGoogleMaps();

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };

  const handleAdd = () => {
    setEditMode(false);
    initializeCustomerData();
    clearErrors();
    setIsAddModalOpen(true);
  };

  // Function to handle location search using Google Maps Geocoding API
  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;

    setCustomerData({
      ...customerData,
      searchlocation: searchValue,
    });

    const query = `${customerData["city"]}, ${customerData["state"]}, ${customerData["country"]}`;
    console.log("query", query);

    try {
       const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          searchValue,
        )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
      );

      const data = await response.json();

      if (data.results && data.results.length > 0) {
        const { lat, lng } = data.results[0].geometry.location;

        setCustomerData((prevData) => ({
          ...prevData,
          latitude: lat,
          longitude: lng,
        }));

        if (mapRef.current) {
          mapRef.current.setCenter({ lat, lng });
          mapRef.current.setZoom(12);
        }

        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        }
      } else {
        console.log("No results found.");
      }
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  //get All Customers data
  const {
    data: customersData,
    isLoading: isCutomersDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getCustomerFindById", customerId), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: updateCustomersData,
    isLoading: updateCustomersLoading,
    error: updateCustomersError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: updateCustomerAddressData,
    isLoading: updateCustomerAddressLoading,
    error: updateCustomerAddressError,
    updateData: fetchUpdateCustomerAddress,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  const {
    data: deleteCustomerAddressData,
    isLoading: deleteCustomerAddressLoading,
    error: deleteCustomerAddressError,
    deleteData: fetchDeleteCustomerAddress,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  //Create Address
  useEffect(() => {
    if (createAddressError) {
    } else if (createAddress && createAddress["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createAddress["message"],
        status: createAddress["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    } else if (createAddress && createAddress["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createAddress["message"],
        status: createAddress["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    }
  }, [createAddress, createAddressError]);

  useEffect(() => {
    if (primaryAddressError) {
    } else if (primaryAddress && primaryAddress["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: primaryAddress["message"],
        status: primaryAddress["status"],
      });
      setModalOpen(true);
    } else if (primaryAddress && primaryAddress["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: primaryAddress["message"],
        status: primaryAddress["status"],
      });
      setModalOpen(true);
    }
  }, [primaryAddress, primaryAddressError]);

  const {
    data: logoutProfile,
    isLoading: logoutProfileLoading,
    error: logoutProfileError,
    fetchData: fetchLogout,
  } = useFetch(BASE_URL_TEST + urls("logoutProfile"), {
    method: "GET",
    headers: {
      Authorization: apptoken ? `Bearer ${apptoken}` : "",
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      if (error) {
        // Handle error case here
      } else if (customersData && customersData["status"] === true) {
        setData(customersData["data"]);
        const customer = customersData["data"];
        setCustomerData({
          ...customerData,
          firstName: customer["first_name"],
          lastName: customer["last_name"],
          location: customer["location"],
          email: customer["email"],
          dob: customer.dob,
          phoneNumber: customer["phone_number"],
          status: customer["status"],
          profilePhoto: customer["profile"],
          country: customer["country"],
          state: customer["state"],
          city: customer["city"],
          street: customer["street"],
          landmark: customer["landmark"],
          pincode: customer["pincode"],
          // latitude: customer["latitude"],//commented on 26-07-25
          // longitude: customer["longitude"],//commented on 26-07-25
        });

        if (customer.latitude && customer.longitude) {
          const latitude = parseFloat(customer.latitude);
          const longitude = parseFloat(customer.longitude);
          try {
            const reverseGeocodeResponse = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${customer.latitude},${customer.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
            );
            const reverseGeocodeData = await reverseGeocodeResponse.json();

            if (
              reverseGeocodeData.results &&
              reverseGeocodeData.results.length > 0
            ) {
              const address = reverseGeocodeData.results[0].formatted_address;

              // Update customer data with the formatted address (location)
              setCustomerData((prevData) => ({
                ...prevData,
                searchlocation: address,
              }));
            }

            setTimeout(() => {
              if (mapRef.current) {
                const map = mapRef.current;
                const center = { lat: latitude, lng: longitude };
                map.panTo(center);
                map.setZoom(15);
              }

              if (markerRef.current) {
                markerRef.current.setPosition({
                  lat: latitude,
                  lng: longitude,
                });
              }
            }, 100);
          } catch (error) {
            console.error("Error fetching location:", error);
          }
        }
      }
    };

    fetchData(); // Call the async function inside useEffect
  }, [customersData, error]);

  useEffect(() => {
    if (updateCustomersError) {
    } else if (updateCustomersData && updateCustomersData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomersData["message"],
        status: updateCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateCustomersData && updateCustomersData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomersData["message"],
        status: updateCustomersData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateCustomersData, updateCustomersError]);

  useEffect(() => {
    if (updateCustomerAddressError) {
    } else if (
      updateCustomerAddressData &&
      updateCustomerAddressData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomerAddressData["message"],
        status: updateCustomerAddressData["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    } else if (
      updateCustomerAddressData &&
      updateCustomerAddressData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateCustomerAddressData["message"],
        status: updateCustomerAddressData["status"],
      });
      setModalOpen(true);
      fetchAddressData();
    }
  }, [updateCustomerAddressData, updateCustomerAddressError]);

  //Delete Vendor
  useEffect(() => {
    if (deleteCustomerAddressError) {
    } else if (
      deleteCustomerAddressData &&
      deleteCustomerAddressData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCustomerAddressData["message"],
        status: deleteCustomerAddressData["status"],
      });
      setDeleteModalOpen(true);
      fetchAddressData();
    } else if (
      deleteCustomerAddressData &&
      deleteCustomerAddressData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: deleteCustomerAddressData["message"],
        status: deleteCustomerAddressData["status"],
      });
      setDeleteModalOpen(true);
      fetchAddressData();
    }
  }, [deleteCustomerAddressData, deleteCustomerAddressError]);

  const handleLogoutClick = () => {
    fetchLogout();
  };

  useEffect(() => {
    if (logoutProfileError) {
    } else if (logoutProfile && logoutProfile["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: logoutProfile["message"],
        status: logoutProfile["status"],
      });
      setModalOpen(true);
      dispatch(getAppToken(""));
      dispatch(getCustomerId(""));
      setTimeout(() => {
        navigate("/");
      }, 2000);
    } else if (logoutProfile && logoutProfile["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: logoutProfile["message"],
        status: logoutProfile["status"],
      });
      setModalOpen(true);
    }
  }, [logoutProfile, logoutProfileError]);

  const handleSave = () => {
    const formdata = new FormData();
    formdata.append("first_name", customerData["firstName"]);
    formdata.append("last_name", customerData["lastName"]);
    formdata.append("location", customerData["location"]);
    formdata.append("email", customerData["email"]);
    formdata.append("phone_number", customerData["phoneNumber"]);
    formdata.append("status", customerData["status"]);
    formdata.append(
      "dob",
      customerData.dob ? convertDate(customerData.dob) : null,
    );
    formdata.append("country", customerData["country"]);
    formdata.append("state", customerData["state"]);
    formdata.append("city", customerData["location"]);
    formdata.append("street", customerData["street"]);
    formdata.append("landmark", customerData["landmark"]);
    formdata.append("pincode", customerData["pincode"]);
    formdata.append("latitude", customerData["latitude"]);
    formdata.append("longitude", customerData["longitude"]);
    formdata.append(
      "profile",
      selectedFile ? selectedFile : customerData["profile"],
    );

    for (let [key, value] of formdata.entries()) {
      console.log("Form Data Contentsupdate:", `${key}: ${value}`);
    }
    const updateUrl = urls("updateCustomer", customerId);
    console.log("updateurl", updateUrl);
    fetchUpdateData(updateUrl, formdata);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSaveAddress = () => {
    let validationErrors = {};
    if (!validateCountry(customerData.country)) {
      validationErrors.country =
        "Country is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateState(customerData.state)) {
      validationErrors.state =
        "State is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!validateCity(customerData.city)) {
      validationErrors.city =
        "City is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!validateStreet(customerData.street)) {
      validationErrors.street =
        "Street is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes.";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(customerData.landmark)) {
      validationErrors.landmark = "Landmark is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePincode(customerData.pincode)) {
      validationErrors.pincode = "Pincode should be a 6-digit number.";
      setErrors(validationErrors);
      return;
    }
    if (!validateLandmark(customerData.searchlocation)) {
      validationErrors.searchlocation = "Location is required.";
      setErrors(validationErrors);
      return;
    }
    clearErrors();

    const saveBody = {
      ...(!isEditMode
        ? {
            user_id: customerId,
            is_primary: customerData?.isDefault ? 1 : 0,
          }
        : {}),
      country: customerData?.country,
      state: customerData?.state,
      city: customerData?.city,
      street: customerData?.street,
      landmark: customerData?.landmark,
      pincode: customerData?.pincode,
      latitude: customerData?.latitude,
      longitude: customerData?.longitude,
    };
    if (isEditMode) {
      const updateUrl = urls("updateCustomerAddress", customerData?.addressId);
      fetchUpdateCustomerAddress(updateUrl, saveBody);
    } else if (!isEditMode) {
      fetchCreateData(saveBody);
    }
  };

  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);

    if (updateCustomersData && updateCustomersData["status"] === true) {
      setCustomerData({
        latitude: "",
        longitude: "",
      });
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const handleCloseAddress = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();

    if (createAddress && createAddress["status"] === true) {
      initializeCustomerData();
      setCustomerData({
        latitude: "",
        longitude: "",
      });
      setIsAddModalOpen(false);
    }
    if (isEditMode) {
      if (
        updateCustomerAddressData &&
        updateCustomerAddressData["status"] === true
      ) {
        initializeCustomerData();
        setCustomerData({
          latitude: "",
          longitude: "",
        });
        setIsAddModalOpen(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  const handleProfileImage = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCustomerData({
        ...customerData,
        profilePhoto: URL.createObjectURL(file),
      });
      setSelectedFile(file);
    }
  };

  const handleSetDefaultAddress = (addressId) => {
    const updatedAddresses = addressList.map((address) => ({
      ...address,
      is_primary: address.address_id === addressId ? 1 : 0,
    }));

    setAddressList(updatedAddresses);

    const setPrimaryAddress = {
      user_id: customerId,
      address_id: addressId,
    };

    console.log("Setting primary address:", setPrimaryAddress);
    fetchSetPrimaryAddress(setPrimaryAddress);
  };

  const handleEdit = async (address) => {
    console.log("Editing address:", address);

    setEditMode(true);
    setCustomerData({
      country: address.country || "",
      state: address.state || "",
      city: address.city || "",
      street: address.street || "",
      landmark: address.landmark || "",
      pincode: address.pincode || "",
      isDefault: address.is_primary === 1,
      searchlocation: "",
      latitude: address.latitude || "",
      longitude: address.longitude || "",
      addressId: address.address_id || "",
    });

    if (address.latitude && address.longitude) {
      const latitude = parseFloat(address.latitude);
      const longitude = parseFloat(address.longitude);
      try {
        const reverseGeocodeResponse = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${address.latitude},${address.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
        );
        const reverseGeocodeData = await reverseGeocodeResponse.json();

        if (
          reverseGeocodeData.results &&
          reverseGeocodeData.results.length > 0
        ) {
          const address = reverseGeocodeData.results[0].formatted_address;

          // Update customer data with the formatted address (location)
          setCustomerData((prevData) => ({
            ...prevData,
            searchlocation: address,
          }));
        }
        setTimeout(() => {
          if (mapRef.current) {
            const map = mapRef.current;
            const center = { lat: latitude, lng: longitude };
            map.panTo(center);
            map.setZoom(15);
          }

          if (markerRef.current) {
            markerRef.current.setPosition({ lat: latitude, lng: longitude });
          }
        }, 100);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
  };

  const handleDelete = (addressId) => {
    const deleteUrl = urls("deleteCustomerAddress", addressId);
    fetchDeleteCustomerAddress(deleteUrl);
  };
  const renderContent = () => {
    if (activeTab === "Profile Information") {
      return (
        <Box sx={{ padding: "25px", flex: 1 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, mb: 3, color: "#333" }}
          >
            Personal Information
          </Typography>
          {[
            {
              label: "First Name",
              name: "firstName",
              value: customerData?.firstName,
            },
            {
              label: "Last Name",
              name: "lastName",
              value: customerData?.lastName,
            },
          ].map((field, index) => (
            <Box
              key={index}
              sx={{ display: "flex", flexDirection: "column", mb: 3 }}
            >
              <TextField
                fullWidth
                label={field.label}
                name={field.name}
                value={field.value || ""}
                onChange={handleInputChange}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  flex: 1,
                  maxWidth: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#FB4923",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "12px 16px",
                  },
                }}
              />
            </Box>
          ))}
          {[
            {
              label: "Email Address",
              name: "email",
              value: customerData?.email,
              readOnly: false,
            },
            {
              label: "Mobile Number",
              name: "phoneNumber",
              value: customerData?.phoneNumber,
              readOnly: true,
            },
          ].map((field, index) => (
            <Box
              key={index}
              sx={{ display: "flex", flexDirection: "column", mb: 3 }}
            >
              <TextField
                fullWidth
                label={field.label}
                name={field.name}
                value={field.value}
                onChange={handleInputChange}
                margin="normal"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: field.readOnly,
                }}
                sx={{
                  flex: 1,
                  maxWidth: "100%",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    "&:hover fieldset": {
                      borderColor: "#FB4923",
                    },
                  },
                  "& .MuiOutlinedInput-input": {
                    padding: "12px 16px",
                  },
                }}
              />
            </Box>
          ))}

          <Box sx={{ display: "flex", flexDirection: "column", mb: 3 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DesktopDatePicker
                label="Date of Birth"
                value={customerData.dob ? new Date(customerData.dob) : null}
                maxDate={new Date()}
                onChange={(newValue) => {
                  setCustomerData({ ...customerData, dob: newValue });
                }}
                renderInput={(params) => (
                  <TextField {...params} fullWidth sx={{ mb: 4 }} />
                )}
              />
            </LocalizationProvider>
          </Box>
          <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
            <Grid item xs={12} sm={3}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                Profile photo
              </Typography>
              <Avatar
                alt="Profile"
                src={customerData?.profilePhoto || "/default-profile.png"}
                sx={{
                  width: 100,
                  height: 100,
                  border: "2px solid #ddd",
                  mb: 1,
                }}
              />
              <Typography variant="body2" color="textSecondary" marginTop={1}>
                Image should be in 300 X 300.(size:40kb)
              </Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadFile />}
                sx={{
                  mr: 2,
                  bgcolor: "#3f51b5",
                  "&:hover": { bgcolor: "#303f9f" },
                }}
              >
                Upload Image
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={handleProfileImage}
                />
              </Button>

              <Button
                variant="outlined"
                startIcon={<Delete />}
                onClick={() => {
                  setCustomerData((prevData) => ({
                    ...prevData,
                    profilePhoto: "",
                  }));
                }}
                sx={{
                  color: "#f44336",
                  borderColor: "#f44336",
                  "&:hover": { bgcolor: "#ffe6e6" },
                }}
              >
                Delete
              </Button>
            </Grid>
          </Grid>

          {/* Save Button */}
          <Button
            variant="contained"
            color="primary"
            sx={{
              marginTop: "24px",
              background: "#FB4923",
              borderRadius: "8px",
              padding: "10px 24px",
              textTransform: "none",
              fontWeight: 600,
              boxShadow: "0px 4px 10px rgba(251, 73, 35, 0.3)",
              "&:hover": {
                background: "#E03A18",
              },
            }}
            onClick={handleSave}
          >
            Save
          </Button>
          <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
            <DialogTitle>
              {snackbarState.status === true ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.message}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                sx={{
                  textTransform: "none",
                  borderRadius: 2,
                  alignSelf: "center",
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      );
    } else if (activeTab === "Manage Addresses") {
      return (
        <Box sx={{ padding: "28px", flex: 1 }}>
          {/* Title and Add Button */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="h6"
              gutterBottom
              sx={{ fontWeight: 600, color: "#333" }}
            >
              Manage Addresses
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleAdd}
              sx={{
                textTransform: "none",
                borderRadius: "8px",
                background: "#1976d2",
                fontWeight: 600,
              }}
            >
              Add
            </Button>
          </Box>

          {/* Add Address Dialog */}
          <Dialog
            open={isAddModalOpen}
            onClose={() => setIsAddModalOpen(false)}
            fullWidth
            maxWidth={false}
            sx={{
              "& .MuiDialog-paper": {
                width: "95%",
                height: "95vh",
                maxWidth: "none",
                maxHeight: "none",
              },
            }}
          >
            <DialogTitle>Add New Address</DialogTitle>
            <DialogContent>
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <TextField
                  margin="dense"
                  label="Country"
                  fullWidth
                  value={customerData?.country || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      country: e.target.value,
                    })
                  }
                  error={!!errors.country}
                  helperText={
                    errors.country && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.country}
                      </Typography>
                    )
                  }
                />
                <TextField
                  margin="dense"
                  label="State"
                  fullWidth
                  value={customerData?.state || ""}
                  onChange={(e) =>
                    setCustomerData({ ...customerData, state: e.target.value })
                  }
                  error={!!errors.state}
                  helperText={
                    errors.state && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.state}
                      </Typography>
                    )
                  }
                />
                <TextField
                  margin="dense"
                  label="City"
                  fullWidth
                  value={customerData?.city || ""}
                  onChange={(e) =>
                    setCustomerData({ ...customerData, city: e.target.value })
                  }
                  error={!!errors.city}
                  helperText={
                    errors.city && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.city}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                <TextField
                  margin="dense"
                  label="House No/Flat No, Street Name"
                  fullWidth
                  value={customerData?.street || ""}
                  onChange={(e) =>
                    setCustomerData({ ...customerData, street: e.target.value })
                  }
                  error={!!errors.street}
                  helperText={
                    errors.street && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.street}
                      </Typography>
                    )
                  }
                />
                <TextField
                  margin="dense"
                  label="Landmark"
                  fullWidth
                  value={customerData?.landmark || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      landmark: e.target.value,
                    })
                  }
                  error={!!errors.landmark}
                  helperText={
                    errors.landmark && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.landmark}
                      </Typography>
                    )
                  }
                />
                <TextField
                  margin="dense"
                  label="Pincode"
                  fullWidth
                  value={customerData?.pincode || ""}
                  onChange={(e) =>
                    setCustomerData({
                      ...customerData,
                      pincode: e.target.value,
                    })
                  }
                  error={!!errors.pincode}
                  helperText={
                    errors.pincode && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.pincode}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={customerData?.isDefault || false}
                      onChange={(e) =>
                        setCustomerData({
                          ...customerData,
                          isDefault: e.target.checked,
                        })
                      }
                      color="primary"
                    />
                  }
                  label="Make this as default address"
                />
              </Box>

              {/* Location Search */}
              <Box sx={{ mt: 2 }}>
                <Typography variant="h6">Select Location</Typography>
                <TextField
                  fullWidth
                  margin="dense"
                  label="Search Location"
                  variant="outlined"
                  sx={{ mt: 2 }}
                  value={customerData?.searchlocation}
                  onChange={handleLocationSearch}
                  error={!!errors.searchlocation}
                  helperText={
                    errors.searchlocation && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.searchlocation}
                      </Typography>
                    )
                  }
                />

                {/* Map Component */}
                {isLoaded ? (
                  <Box>
                    <GoogleMap
                      ref={mapRef}
                      onLoad={(map) => {
                        mapRef.current = map;
                        if (customerData.latitude && customerData.longitude) {
                          map.panTo({
                            lat: parseFloat(customerData.latitude),
                            lng: parseFloat(customerData.longitude),
                          });
                          map.setZoom(15);
                        }
                      }}
                      center={{
                        lat: parseFloat(customerData.latitude) || 0,
                        lng: parseFloat(customerData.longitude) || 0,
                      }}
                      zoom={13}
                      mapContainerStyle={{
                        height: "400px",
                        width: "100%",
                        marginTop: "20px",
                      }}
                      options={{
                        streetViewControl: false,
                        mapTypeControl: false,
                      }}
                    >
                      <LocationPicker
                        setLatitude={(lat) =>
                          setCustomerData((prevData) => ({
                            ...prevData,
                            latitude: lat,
                          }))
                        }
                        setLongitude={(lon) =>
                          setCustomerData((prevData) => ({
                            ...prevData,
                            longitude: lon,
                          }))
                        }
                      />
                      {customerData.latitude && customerData.longitude && (
                        <MarkerF
                          ref={markerRef}
                          position={{
                            lat: parseFloat(customerData.latitude),
                            lng: parseFloat(customerData.longitude),
                          }}
                          draggable={true}
                          onDragEnd={async (event) => {
                            const lat = event.latLng.lat();
                            const lng = event.latLng.lng();

                            try {
                              const response = await fetch(
                                `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
                              );

                              const data = await response.json();

                              if (data.results && data.results.length > 0) {
                                const newAddress =
                                  data.results[0].formatted_address;

                                setCustomerData((prev) => ({
                                  ...prev,
                                  latitude: lat,
                                  longitude: lng,
                                  searchlocation: newAddress,
                                }));
                              }
                            } catch (error) {
                              console.error("Reverse geocode error:", error);
                            }
                          }}
                          icon={createRedIcon()}
                          onClick={() => setInfoWindowOpen(true)}
                        >
                          {isInfoWindowOpen && (
                            <InfoWindowF
                              position={{
                                lat: parseFloat(customerData.latitude),
                                lng: parseFloat(customerData.longitude),
                              }}
                              onCloseClick={() => setInfoWindowOpen(false)}
                            >
                              <div>
                                <p>
                                  Latitude: {customerData.latitude}, Longitude:{" "}
                                  {customerData.longitude}
                                </p>
                              </div>
                            </InfoWindowF>
                          )}
                        </MarkerF>
                      )}
                    </GoogleMap>
                  </Box>
                ) : (
                  <Typography>Loading map...</Typography>
                )}

                {/* Latitude & Longitude display */}
                <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                  <TextField
                    margin="dense"
                    label="Latitude"
                    fullWidth
                    value={customerData?.latitude}
                    InputProps={{ readOnly: true }}
                  />
                  <TextField
                    margin="dense"
                    label="Longitude"
                    fullWidth
                    value={customerData?.longitude || ""}
                    InputProps={{ readOnly: true }}
                  />
                </Box>
              </Box>
            </DialogContent>

            {/* Actions */}
            <DialogActions>
              <Button
                onClick={() => setIsAddModalOpen(false)}
                color="secondary"
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  background: "#FB4923",
                  borderRadius: "8px",
                  padding: "10px 24px",
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "0px 4px 10px rgba(251, 73, 35, 0.3)",
                  "&:hover": { background: "#E03A18" },
                }}
                onClick={handleSaveAddress}
              >
                {isEditMode ? "Update" : "Save"}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Success/Error Modal */}
          <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
            <DialogTitle>
              {snackbarState.status === true ? "Success" : "Error"}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.message}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleCloseAddress}
                sx={{ textTransform: "none", borderRadius: 2 }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
          >
            <DialogTitle>
              {snackbarState.status === true
                ? "Success"
                : snackbarState.status === false
                  ? "Error"
                  : ""}
            </DialogTitle>
            <DialogContent>
              <Typography
                variant="body1"
                sx={{
                  color: snackbarState.status === true ? "green" : "red",
                }}
              >
                {snackbarState.message}
              </Typography>
            </DialogContent>
            <DialogActions
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={handleClose}
                sx={{ textTransform: "none", borderRadius: 2 }}
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
          <Grid container spacing={2}>
            {addressList.map((address) => (
              <Grid item xs={12} sm={6} key={address.address_id}>
                <Card
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <CardContent>
                    <Typography variant="subtitle1" fontWeight={600}>
                      {address.street}, {address.city}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Landmark: {address.landmark}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {address.state}, {address.country} - {address.pincode}
                    </Typography>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={address.is_primary === 1}
                          onChange={() =>
                            handleSetDefaultAddress(address.address_id)
                          }
                          color="primary"
                        />
                      }
                      label="Default Address"
                      sx={{ mt: 1 }}
                    />
                  </CardContent>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: 1,
                      mt: 1,
                    }}
                  >
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        handleEdit(address);
                        setIsAddModalOpen(true);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      color="error"
                      onClick={() => {
                        handleDelete(address.address_id);
                      }}
                    >
                      Delete
                    </Button>
                  </Box>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      );
    } else if (activeTab === "PAN Card Information") {
      return (
        <Box sx={{ padding: "28px", flex: 1 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, color: "#333" }}
          >
            PAN Card Information
          </Typography>
          <Typography variant="body1">PAN Card details section.</Typography>
        </Box>
      );
    } else if (activeTab === "On the way") {
      return <OnTheWay />;
    } else if (activeTab === "Confirmed") {
      return <Confirmed />;
    } else if (activeTab === "Delivered") {
      return <Delivered />;
    } else if (activeTab === "Cancelled") {
      return <Cancelled />;
    }
    // else if (activeTab === "Returned") {
    //   return <Returned />;

    // }
    else if (activeTab === "On the way Listing") {
      return <OnTheWayListing />;
    } else if (activeTab === "Confirmed Listing") {
      return <ConfirmedListing />;
    } else if (activeTab === "Delivered Listing") {
      return <DeliveredListing />;
    } else if (activeTab === "Cancelled Listing") {
      return <CancelledListing />;
    }
    // else if (activeTab === "Returned Listing") {
    //   return <ReturnedListing />;
    // }
    else if (
      ["Redeem Points", "Saved UPI", "Saved Cards"].includes(activeTab)
    ) {
      return (
        <Box sx={{ padding: "28px", flex: 1 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, color: "#333" }}
          >
            {activeTab}
          </Typography>
          <Typography variant="body1">
            Payment details for {activeTab}.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }} color="primary.main">
            Coming Soon
          </Typography>
        </Box>
      );
    } else if (
      ["My Coupons", "My Subscriptions", "My Wishlist"].includes(activeTab)
    ) {
      return (
        <Box sx={{ padding: "28px", flex: 1 }}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, color: "#333" }}
          >
            {activeTab}
          </Typography>
          <Typography variant="body1">Details for {activeTab}.</Typography>
          <Typography variant="body1" sx={{ mt: 1 }} color="primary.main">
            Coming Soon
          </Typography>
        </Box>
      );
    }
    return null;
  };
  const sidebar = (
    <Box sx={{ width: 250 }} role="presentation">
      <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
        <Avatar sx={{ width: 40, height: 40, mr: 2 }}>K</Avatar>
        <Typography variant="subtitle1" noWrap>
          {customerData?.firstName}
        </Typography>
      </Box>
      <Divider />

      <List>
        <ListItem>
          <Box sx={{ display: "flex", alignItems: "center", color: "#FB4923" }}>
            <PersonIcon fontSize="small" sx={{ mr: 1 }} />
            <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
              Account Settings
            </Typography>
          </Box>
        </ListItem>

        {[
          "Profile Information",
          "Manage Addresses",
          // "PAN Card Information",
        ].map((text) => (
          <ListItem
            button
            key={text}
            selected={activeTab === text}
            onClick={() => {
              setActiveTab(text);
              setDrawerOpen(false);
            }}
            sx={{
              pl: 4,
              backgroundColor: activeTab === text ? "#FFF3EC" : "transparent",
              color: activeTab === text ? "#FB4923" : "#555",
              borderLeft:
                activeTab === text
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}

        {/* Other menu sections */}
        <ListItem sx={{ mt: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", color: "#FB4923" }}>
            <ShoppingCartIcon fontSize="small" sx={{ mr: 1 }} />
            <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
              My Orders
            </Typography>
          </Box>
        </ListItem>

        {["On the way", "Confirmed", "Delivered", "Cancelled"].map((text) => (
          <ListItem
            button
            key={text}
            selected={activeTab === text}
            onClick={() => {
              setActiveTab(text);
              setDrawerOpen(false);
            }}
            sx={{
              pl: 4,
              backgroundColor: activeTab === text ? "#FFF3EC" : "transparent",
              color: activeTab === text ? "#FB4923" : "#555",
              borderLeft:
                activeTab === text
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}
        {[
          "On the way Listing",
          "Confirmed Listing",
          "Delivered Listing ",
          "Cancelled Listing",
          // "Returned Listing",
        ].map((text) => (
          <ListItem
            button
            key={text}
            selected={activeTab === text}
            onClick={() => {
              setActiveTab(text);
              setDrawerOpen(false);
            }}
            sx={{
              pl: 4,
              backgroundColor: activeTab === text ? "#FFF3EC" : "transparent",
              color: activeTab === text ? "#FB4923" : "#555",
              borderLeft:
                activeTab === text
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <ListItemText primary={text} />
          </ListItem>
        ))}
        <ListItem sx={{ mt: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", color: "#FB4923" }}>
            <PaymentIcon fontSize="small" sx={{ mr: 1 }} />
            <Typography sx={{ fontWeight: 600, fontSize: "0.9rem" }}>
              My Payments
            </Typography>
          </Box>
        </ListItem>

        <ListItem sx={{ mt: 2, color: "#FF4A4A" }} button>
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
          <ListItemText primary="Logout" />
        </ListItem>
      </List>
    </Box>
  );

  const renderSidebar = () => (
    <Box sx={{ width: 280, p: 2 }}>
      {/* User Info */}
      <Grid container alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Grid item>
          <Avatar src="/profile.jpg" sx={{ width: 48, height: 48 }} />
        </Grid>
        <Grid item>
          <Typography variant="subtitle1" fontWeight="bold">
            {customerData?.firstName}
          </Typography>
        </Grid>
      </Grid>

      <List sx={{ p: 0 }}>
        {/* Account Settings */}
        <Box
          display="flex"
          alignItems="center"
          sx={{ py: 1.5, px: 1, background: "#FFF8F5", borderRadius: 1 }}
        >
          <Person2Rounded sx={{ color: "#FB4923" }} />
          <Typography sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}>
            Account Settings
          </Typography>
        </Box>

        {["Profile Information", "Manage Addresses"].map((tab) => (
          <ListItem
            button
            key={tab}
            selected={activeTab === tab}
            onClick={() => setActiveTab(tab)}
            sx={{
              pl: 3.5,
              my: 0.5,
              borderRadius: 1,
              backgroundColor: activeTab === tab ? "#FFF3EC" : "transparent",
              color: activeTab === tab ? "#FB4923" : "#555",
              borderLeft:
                activeTab === tab
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
              "&:hover": { backgroundColor: "#FFF3EC" },
              transition: "all 0.2s",
            }}
          >
            <ListItemText
              primary={tab}
              primaryTypographyProps={{
                fontSize: "0.9rem",
                fontWeight: activeTab === tab ? 600 : 400,
              }}
            />
          </ListItem>
        ))}

        {/* My Orders */}
        <Box
          display="flex"
          alignItems="center"
          sx={{ py: 1.5, px: 1, mt: 2, background: "#FFF8F5", borderRadius: 1 }}
        >
          <ShoppingCartIcon sx={{ color: "#FB4923" }} />
          <Typography sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}>
            My Orders
          </Typography>
        </Box>

        {["On the way", "Delivered", "Cancelled"].map((tab) => (
          <ListItem
            button
            key={tab}
            selected={activeTab === tab}
            onClick={() => setActiveTab(tab)}
            sx={{
              pl: 3.5,
              my: 0.5,
              borderRadius: 1,
              backgroundColor: activeTab === tab ? "#FFF3EC" : "transparent",
              color: activeTab === tab ? "#FB4923" : "#555",
              borderLeft:
                activeTab === tab
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
              "&:hover": { backgroundColor: "#FFF3EC" },
              transition: "all 0.2s",
            }}
          >
            <ListItemText
              primary={tab}
              primaryTypographyProps={{
                fontSize: "0.9rem",
                fontWeight: activeTab === tab ? 600 : 400,
              }}
            />
          </ListItem>
        ))}

        {/* My Payments */}
        <Box
          display="flex"
          alignItems="center"
          sx={{ py: 1.5, px: 1, mt: 2, background: "#FFF8F5", borderRadius: 1 }}
        >
          <PaymentIcon sx={{ color: "#FB4923" }} />
          <Typography sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}>
            My Payments
          </Typography>
        </Box>

        {["Redeem Points", "Saved UPI", "Saved Cards"].map((tab) => (
          <ListItem
            button
            key={tab}
            selected={activeTab === tab}
            onClick={() => setActiveTab(tab)}
            sx={{
              pl: 3.5,
              my: 0.5,
              borderRadius: 1,
              backgroundColor: activeTab === tab ? "#FFF3EC" : "transparent",
              color: activeTab === tab ? "#FB4923" : "#555",
              borderLeft:
                activeTab === tab
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
              "&:hover": { backgroundColor: "#FFF3EC" },
              transition: "all 0.2s",
            }}
          >
            <ListItemText
              primary={tab}
              primaryTypographyProps={{
                fontSize: "0.9rem",
                fontWeight: activeTab === tab ? 600 : 400,
              }}
            />
          </ListItem>
        ))}

        {/* Logout */}
        <ListItem
          button
          onClick={() => console.log("Logout")}
          sx={{
            color: "#FF4A4A",
            my: 1,
            mt: 3,
            borderRadius: 1,
            "&:hover": { backgroundColor: "#FFF3EC" },
          }}
        >
          <LogoutIcon fontSize="small" sx={{ mr: 1 }} />
          <ListItemText primary="Logout" onClick={handleLogoutClick} />
        </ListItem>
      </List>
    </Box>
  );

  const renderProfileForm = () => (
    <Box sx={{ p: 2 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Profile Information
      </Typography>
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          disabled={!isEditMode}
          label="First Name"
          defaultValue="Ramya Sree"
          size="small"
        />
      </Box>
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          disabled={!isEditMode}
          label="Last Name"
          defaultValue="Kaniyampati"
          size="small"
        />
      </Box>
      {isEditMode && (
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button variant="outlined" onClick={() => setEditMode(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => setEditMode(false)}
            sx={{ bgcolor: "#FB4923", "&:hover": { bgcolor: "#e53b15" } }}
          >
            Save
          </Button>
        </Box>
      )}
    </Box>
  );

  const renderMobileContent = () => {
    console.log("activeTab", activeTab);

    return (
      <Box m={2}>
        <Accordion
          onChange={() => setActiveTab("Profile Information")}
          defaultExpanded
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              // pl: 4,
              backgroundColor:
                activeTab === "Profile Information" ? "#FFF3EC" : "transparent",
              color: activeTab === "Profile Information" ? "#FB4923" : "#555",
              borderLeft:
                activeTab === "Profile Information"
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <Typography component="span">Profile Information</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ padding: " 5px", flex: 1 }}>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: 600, mb: 1, color: "#333", fontSize: 12 }}
              >
                Personal Information
              </Typography>
              {[
                { label: "First Name", value: "Ramya Sree" },
                { label: "Last Name", value: "Kaniyampati" },
              ].map((field, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                    width: "100%",
                  }}
                >
                  <TextField
                    fullWidth
                    label={field.label}
                    defaultValue={field.value}
                    margin="normal"
                    sx={{
                      flex: 1,
                      maxWidth: "100%",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "&:hover fieldset": {
                          borderColor: "#FB4923",
                        },
                      },
                      "& .MuiOutlinedInput-input": {
                        padding: "12px 16px",
                      },
                    }}
                  />
                  <Link
                    href="#"
                    sx={{
                      ml: 2,
                      textDecoration: "none",
                      color: "#FB4923",
                      fontWeight: 500,
                      "&:hover": {
                        textDecoration: "underline",
                      },
                    }}
                  >
                    Edit
                  </Link>
                </Box>
              ))}

              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginTop: "24px",
                  background: "#FB4923",
                  borderRadius: "8px",
                  padding: "10px 24px",
                  textTransform: "none",
                  fontWeight: 600,
                  boxShadow: "0px 4px 10px rgba(251, 73, 35, 0.3)",
                  "&:hover": {
                    background: "#E03A18",
                  },
                }}
              >
                Save
              </Button>
            </Box>
          </AccordionDetails>
        </Accordion>
        <Accordion onChange={() => setActiveTab("Manage Addresses")}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              // pl: 4,
              backgroundColor:
                activeTab === "Manage Addresses" ? "#FFF3EC" : "transparent",
              color: activeTab === "Manage Addresses" ? "#FB4923" : "#555",
              borderLeft:
                activeTab === "Manage Addresses"
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <Typography component="span">Manage Addresses</Typography>
          </AccordionSummary>
          <AccordionDetails>Coming Soon</AccordionDetails>
        </Accordion>
        <Accordion onChange={() => setActiveTab("PAN Card Information")}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
            sx={{
              // pl: 4,
              backgroundColor:
                activeTab === "PAN Card Information"
                  ? "#FFF3EC"
                  : "transparent",
              color: activeTab === "PAN Card Information" ? "#FB4923" : "#555",
              borderLeft:
                activeTab === "PAN Card Information"
                  ? "4px solid #FB4923"
                  : "4px solid transparent",
            }}
          >
            <Typography component="span">PAN Card Information</Typography>
          </AccordionSummary>
          <AccordionDetails>Coming Soon</AccordionDetails>
          <AccordionActions>
            <Button>Cancel</Button>
            <Button>Agree</Button>
          </AccordionActions>
        </Accordion>
      </Box>
    );
  };
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };
  const MobileResponsiveProfile = () => {
    const [activeTab, setActiveTab] = useState("Profile Information");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editMode, setEditMode] = useState(false);

    const renderProfileForm = () => (
      <Box sx={{ p: 2, width: "100%" }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            First Name
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              disabled={!editMode}
              size="small"
              defaultValue="Ramya Sree"
              variant="outlined"
              sx={{ bgcolor: "#f9f9f9" }}
            />
            {!editMode && (
              <IconButton
                color="primary"
                sx={{ ml: 1 }}
                onClick={() => setEditMode(true)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Last Name
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              disabled={!editMode}
              size="small"
              defaultValue="Kaniyampati"
              variant="outlined"
              sx={{ bgcolor: "#f9f9f9" }}
            />
            {!editMode && (
              <IconButton
                color="primary"
                sx={{ ml: 1 }}
                onClick={() => setEditMode(true)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Your Gender
          </Typography>
          <RadioGroup row defaultValue="female">
            <FormControlLabel
              value="male"
              control={<Radio />}
              label="Male"
              disabled={!editMode}
            />
            <FormControlLabel
              value="female"
              control={<Radio />}
              label="Female"
              disabled={!editMode}
            />
          </RadioGroup>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Email Address
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              disabled={!editMode}
              size="small"
              defaultValue="kaniyampatiramyasree@gmail.com"
              variant="outlined"
              sx={{ bgcolor: "#f9f9f9" }}
            />
            {!editMode && (
              <IconButton
                color="primary"
                sx={{ ml: 1 }}
                onClick={() => setEditMode(true)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            Mobile Number
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              fullWidth
              disabled={!editMode}
              size="small"
              defaultValue="9856743284"
              variant="outlined"
              sx={{ bgcolor: "#f9f9f9" }}
            />
            {!editMode && (
              <IconButton
                color="primary"
                sx={{ ml: 1 }}
                onClick={() => setEditMode(true)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        </Box>

        {editMode && (
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
            <Button
              variant="outlined"
              onClick={() => setEditMode(false)}
              sx={{ width: "48%" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={() => setEditMode(false)}
              sx={{
                width: "48%",
                bgcolor: "#FB4923",
                "&:hover": {
                  bgcolor: "#e53b15",
                },
              }}
            >
              Save
            </Button>
          </Box>
        )}
      </Box>
    );

    return (
      <Box sx={{ mb: 8 }}>
        {/* Main Content */}
        <Container maxWidth="sm" sx={{ mt: 2 }}>
          <Paper
            elevation={1}
            sx={{ borderRadius: "12px", overflow: "hidden" }}
          >
            <Box sx={{ p: 2, bgcolor: "#f8f8f8" }}>
              <Typography variant="h6">{activeTab}</Typography>
            </Box>
            <Divider />

            {/* {activeTab === 'Profile Information' && renderProfileForm()} */}
            {renderContent()}
          </Paper>
        </Container>
      </Box>
    );
  };

  return (
    <>
      <Header />
      {isSmallScreen && (
        <Paper
          elevation={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1,
            position: "sticky",
            top: 0,
            zIndex: 1200,
          }}
        >
          <IconButton onClick={toggleDrawer(true)}>
            <MenuIcon />
          </IconButton>
          <Typography variant="subtitle1" fontWeight="bold">
            My Account
          </Typography>
          <Avatar src="/profile.jpg" sx={{ width: 36, height: 36 }} />
        </Paper>
      )}

      {isSmallScreen ? (
        <>
          {/* Mobile Drawer */}
          <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={toggleDrawer(false)}
            PaperProps={{ sx: { width: 280 } }}
          >
            {renderSidebar()}
          </Drawer>

          {/* Mobile Content */}
          <Box sx={{ p: 2 }}>{renderContent()}</Box>
        </>
      ) : (
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            marginTop: "20px",
            marginBottom: "20px",
            gap: "24px",
          }}
        >
          {/* Sidebar section */}
          <Paper
            elevation={3}
            sx={{
              width: 280,
              height: "100vh",
              padding: "24px 16px",
              overflow: "auto",
              borderRadius: "12px",
              position: "sticky",
              top: 0,
              background: "#FFFFFF",
            }}
          >
            <Grid container alignItems="center" spacing={2} sx={{ mb: 3 }}>
              <Grid item>
                <Avatar
                  src="/profile.jpg"
                  alt="User"
                  sx={{
                    width: 48,
                    height: 48,
                    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                  }}
                />
              </Grid>
              <Grid item>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  sx={{ fontSize: "1rem" }}
                >
                  {customerData?.firstName}
                </Typography>
              </Grid>
            </Grid>

            <List sx={{ py: 0 }}>
              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                sx={{
                  py: 1.5,
                  px: 1,
                  mt: 1,
                  borderRadius: "8px",
                  background: "#FFF8F5",
                }}
              >
                <Person2Rounded
                  style={{ stroke: "#FB4923", fill: "#FB4923" }}
                  fontSize="small"
                />
                <Typography
                  sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}
                >
                  Account Settings
                </Typography>
              </Box>
              {[
                "Profile Information",
                "Manage Addresses",
                // "PAN Card Information",
              ].map((tab) => (
                <ListItem
                  button
                  key={tab}
                  selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    backgroundColor:
                      activeTab === tab ? "#FFF3EC" : "transparent",
                    color: activeTab === tab ? "#FB4923" : "#555",
                    borderLeft:
                      activeTab === tab
                        ? "4px solid #FB4923"
                        : "4px solid transparent",
                    borderRadius: "8px",
                    my: 0.5,
                    pl: 3.5,
                    "&:hover": { backgroundColor: "#FFF3EC" },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: activeTab === tab ? 600 : 400,
                    }}
                  />
                </ListItem>
              ))}

              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                sx={{
                  py: 1.5,
                  px: 1,
                  mt: 2,
                  borderRadius: "8px",
                  background: "#FFF8F5",
                }}
              >
                <ShoppingCartIcon
                  style={{ stroke: "#FB4923", fill: "#FB4923" }}
                  fontSize="small"
                />
                <Typography
                  variant="subtitle2"
                  sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}
                >
                  My Orders(Regular)
                </Typography>
              </Box>
              {[
                "On the way",
                "Confirmed",
                "Delivered",
                "Cancelled",
                // "Returned",
              ].map((tab) => (
                <ListItem
                  button
                  key={tab}
                  selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    backgroundColor:
                      activeTab === tab ? "#FFF3EC" : "transparent",
                    color: activeTab === tab ? "#FB4923" : "#555",
                    borderLeft:
                      activeTab === tab
                        ? "4px solid #FB4923"
                        : "4px solid transparent",
                    borderRadius: "8px",
                    my: 0.5,
                    pl: 3.5,
                    "&:hover": { backgroundColor: "#FFF3EC" },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: activeTab === tab ? 600 : 400,
                    }}
                  />
                </ListItem>
              ))}
              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                sx={{
                  py: 1.5,
                  px: 1,
                  mt: 2,
                  borderRadius: "8px",
                  background: "#FFF8F5",
                }}
              >
                <ShoppingCartIcon
                  style={{ stroke: "#FB4923", fill: "#FB4923" }}
                  fontSize="small"
                />
                <Typography
                  variant="subtitle2"
                  sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}
                >
                  My Orders(Listing)
                </Typography>
              </Box>
              {[
                "On the way Listing",
                "Confirmed Listing",
                "Delivered Listing",
                "Cancelled Listing",
                // "Returned Listing",
              ].map((tab) => (
                <ListItem
                  button
                  key={tab}
                  selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    backgroundColor:
                      activeTab === tab ? "#FFF3EC" : "transparent",
                    color: activeTab === tab ? "#FB4923" : "#555",
                    borderLeft:
                      activeTab === tab
                        ? "4px solid #FB4923"
                        : "4px solid transparent",
                    borderRadius: "8px",
                    my: 0.5,
                    pl: 3.5,
                    "&:hover": { backgroundColor: "#FFF3EC" },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: activeTab === tab ? 600 : 400,
                    }}
                  />
                </ListItem>
              ))}
              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                sx={{
                  py: 1.5,
                  px: 1,
                  mt: 2,
                  borderRadius: "8px",
                  background: "#FFF8F5",
                }}
              >
                <PaymentIcon
                  style={{ stroke: "#FB4923", fill: "#FB4923" }}
                  fontSize="small"
                />
                <Typography
                  sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}
                >
                  My Payments
                </Typography>
              </Box>
              {["Redeem Points", "Saved UPI", "Saved Cards"].map((tab) => (
                <ListItem
                  button
                  key={tab}
                  selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    backgroundColor:
                      activeTab === tab ? "#FFF3EC" : "transparent",
                    color: activeTab === tab ? "#FB4923" : "#555",
                    borderLeft:
                      activeTab === tab
                        ? "4px solid #FB4923"
                        : "4px solid transparent",
                    borderRadius: "8px",
                    my: 0.5,
                    pl: 3.5,
                    "&:hover": { backgroundColor: "#FFF3EC" },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: activeTab === tab ? 600 : 400,
                    }}
                  />
                </ListItem>
              ))}

              <Box
                display="flex"
                alignItems="center"
                flexDirection="row"
                sx={{
                  py: 1.5,
                  px: 1,
                  mt: 2,
                  borderRadius: "8px",
                  background: "#FFF8F5",
                }}
              >
                <LocalOfferIcon
                  style={{ stroke: "#FB4923", fill: "#FB4923" }}
                  fontSize="small"
                />
                <Typography
                  sx={{ ml: 1.5, fontWeight: 600, fontSize: "0.9rem" }}
                >
                  Shop Data
                </Typography>
              </Box>
              {["My Coupons", "My Subscriptions", "My Wishlist"].map((tab) => (
                <ListItem
                  button
                  key={tab}
                  selected={activeTab === tab}
                  onClick={() => setActiveTab(tab)}
                  sx={{
                    backgroundColor:
                      activeTab === tab ? "#FFF3EC" : "transparent",
                    color: activeTab === tab ? "#FB4923" : "#555",
                    borderLeft:
                      activeTab === tab
                        ? "4px solid #FB4923"
                        : "4px solid transparent",
                    borderRadius: "8px",
                    my: 0.5,
                    pl: 3.5,
                    "&:hover": { backgroundColor: "#FFF3EC" },
                    transition: "all 0.2s ease-in-out",
                  }}
                >
                  <ListItemText
                    primary={tab}
                    primaryTypographyProps={{
                      fontSize: "0.9rem",
                      fontWeight: activeTab === tab ? 600 : 400,
                    }}
                  />
                </ListItem>
              ))}
              <ListItem
                button
                onClick={handleLogoutClick}
                sx={{
                  color: "#FF4A4A",
                  my: 1,
                  mt: 3,
                  borderRadius: "8px",
                  "&:hover": { backgroundColor: "#FFF3EC" },
                }}
              >
                <LogoutIcon sx={{ mr: 1, fontSize: "1.1rem" }} />
                <ListItemText
                  primary="Logout"
                  primaryTypographyProps={{
                    fontSize: "0.9rem",
                    fontWeight: 500,
                  }}
                />
              </ListItem>
            </List>
          </Paper>

          {/* Content section */}
          <Paper
            elevation={2}
            sx={{
              flex: 1,
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
              overflow: "hidden",
            }}
          >
            {renderContent()}
          </Paper>
        </Container>
      )}

      <UserFooter />
    </>
  );
};

export default ProfileInformation;
